<template>
 
    <div :class="'report_wrap'" ref="turtor" >
         
        <!-- 新闻动态三级页面(详情界面) -->
        <div class="mainbody menus"  v-scroll-animate="'slide-itemgk'" style="width: 90vw; margin: 0 auto;">
          <a href="/home"><i class="el-icon-s-home"></i></a> / <a @click="gocengji0">新闻动态</a> / <a @click="gocengji1">{{nowTab}}  </a> 
          <span class="fontsizeCssy">字体 【 <em @click="fontsize='big'">大</em> <em @click="fontsize='default'">中</em> <em @click="fontsize='small'">小</em> 】</span>
        </div>
        <div class="articleDetailDiv" >
         
      <h1 v-scroll-animate="'fly-in-bottomgy'" class="fontSizeTitle" >{{ articleDetail.title }}</h1>
      <p v-scroll-animate="'fly-in-bottomgy'" class="fontcssxy0 fontSizeTtme">发布时间：{{ articleDetail.createDate.substring(0,16) }}   
        <span v-if="!!articleDetail.copyfrom" style="padding-left: 10px;padding-right:10px;">    来源：{{ articleDetail.copyfrom }} </span> </p>
      <div v-scroll-animate="'fly-in-bottomgy'"  :class="this.fontsize=='big'?'contentcss0 contentcss0big':this.fontsize=='small'?'contentcss0 contentcss0small':'contentcss0'" v-blank-link v-html="articleDetail.content"></div>
      
    <!-- 新增上下篇导航 -->
    <div class="detail-pagination">
      <div class="pagination-bg">
        <div class="prev-article">
          <template v-if="prevArticle">
            <span class="pagination-label">上一篇：</span>
            <a @click="goArticleDetail1(prevArticle.id)" class="article-title">{{ prevArticle.title }}</a>
          </template>
          <template v-else>
            <span class="pagination-label">上一篇：</span>
            <span class="no-article">没有了</span>
          </template>
        </div>
        <div class="next-article">
          <template v-if="nextArticle">
            <span class="pagination-label">下一篇：</span>
            <a @click="goArticleDetail1(nextArticle.id)" class="article-title">{{ nextArticle.title }}</a>
          </template>
          <template v-else>
            <span class="pagination-label">下一篇：</span>
            <span class="no-article">没有了</span>
          </template>
        </div>
      </div>
    </div>
  </div>
        <div class="articleDetailDiv" v-if="cengji == 2 && typeObj == 4">
           <div class="videoDiv" v-scroll-animate="'fly-in-right5gy'"> 
              <video :src="articleDetail.link" class="videoLeft" controls />
            </div>
            <div v-scroll-animate="'fly-in-bottomgy'" class="videoDetail">详情：{{ articleDetail.detail }}</div>
            <!-- <p>发布时间：{{ articleDetail.createDate }}     来源：{{ articleDetail.copyfrom }}   点击量：{{ articleDetail.hits }}</p> -->
          
        </div>
    </div>

    

  </template>
  
  <script>
  import API from '@/api/index'

  import BScroll from '@better-scroll/core'
  import Pullup from '@better-scroll/pull-up'
  import MouseWheel from '@better-scroll/mouse-wheel'
  BScroll.use(Pullup)
  BScroll.use(MouseWheel)
  // import MediaList from '@/utils/mediaList.json'
  
  export default {
    data() {
      return {
        fontsize:'default',
        articleDetail:[],
        currentPage:1,
        totalNum:0,
        pageSize:9,
        cengji:0, // 当前页面层级
        typeObj:null, // 新闻类型
        nowTab:null,
       urlBase: process.env.VUE_APP_BASE_API,
        activeIndex: 0,
      
        columnList: [],
        columnList1:[],
        columnListNow:[], // 二级页面列表
        backStr:false,
        artId:null
       }
    },
    
    created() {
    
  },
    mounted() {
        this.getlist()
      this.artId=this.$route.query.artId
      this.typeObj=this.$route.query.typeObj
     
     
    
    },
    computed: {
    totalPage() {
      return Math.ceil(this.totalNum / this.pageSize); // 确保使用组件内pageSize
    },
    pageRange() {
      return Array.from({length: this.totalPage}, (_, i) => i + 1)
    },
    prevArticle() {
      const index = this.columnListNow.findIndex(item => item.id === this.articleDetail.id);
      return index > 0 ? this.columnListNow[index - 1] : null;
    },
    nextArticle() {
      
      const index = this.columnListNow.findIndex(item => item.id === this.articleDetail.id);
      return index < this.columnListNow.length - 1 ? this.columnListNow[index + 1] : null;
    }
  },
    methods: {
     
      listVueFn(obj){
       
        if(this.backStr){
          this.cengji=0
        }else{
          this.cengji--
        }

        if(obj != null){
          this.cengji=obj
        }
      },
      // 新闻动态往二级页面跳转，传参
      golist(obj){
        this.cengji=1
        this.typeObj=obj
        this.getlist2()
        // this.$emit('cengjiObjFn',{obj:this.cengji})
      },
      // 新闻动态二级页面切换菜单
      changeTypeobj(obj){
        this.typeObj=obj
        this.nowTab= this.columnList1[obj].name
        this.currentPage=1
        this.getlist2()
      },
      gocengji0(){

          const targetRoute = this.$router.resolve({
             path: '/news', 
          });
          window.open(targetRoute.href, '_blank');
 
    },
     gocengji1(){
        const targetRoute = this.$router.resolve({
             path: '/news',
             query: {                     
               cengji: 1,
              typeObj:this.typeObj
             }
          });
          window.open(targetRoute.href, '_blank');

       
    },
    goMore(){
      this.cengji++
    },
      // 新闻动态一级页面获取列表接口方法
      async getlist() {
      try {
        let objParams={
        catId:10,
        pageNum:1,
        pageSize:4
      }
        const res = await API.getArticleByIdNew(objParams)
        this.columnList=res.data.titleList.slice(0,4)  // 新闻动态1级页面 四列展示内容
        this.columnList1=res.data.titleList.slice(0,5) // 新闻动态2级页面 新闻菜单分类 五类
         this.goArticleDetail(this.artId)
        console.log('获取成功', res.data.titleList)
      } catch (error) {
        console.error('获取失败', error)
      }
      },
      // 新闻动态二级列表页面 获取数据方法
      async getlist2() {
        console.log('开始=================================================================')
        console.log(this.columnList1)
        console.log(this.typeObj)
        console.log(this.columnList1[this.typeObj].id)
       
      try {
         let objParams={
          catId:this.columnList1[this.typeObj].id,
          pageNum:this.currentPage
        }
        const res = await API.getArticleById(objParams)
        this.columnListNow=res.data.artList 
        
        this.nowTab=this.columnList1[this.typeObj].name
        
        this.totalNum=res.data.totalNum
        this.totalPage=res.data.totalPage
        
        console.log('获取成功', res.data.artList)
      } catch (error) {
        console.error('获取失败', error)
      }
      },
      pageChange(page) {
      this.currentPage = page
      this.getlist2()
    },
    handleFirstPage() {
      if (this.currentPage !== 1) {
        this.pageChange(1)
      }
    },
    handleLastPage() {
      const last = this.totalPage
      if (this.currentPage !== last) {
        this.pageChange(last)
      }
    },
    
    goArticleDetail1(artId){
        const targetRoute = this.$router.resolve({
             path: '/Newsdetail',
             query: {                     
               artId: artId,
               typeObj:this.typeObj
             }
          });
          window.open(targetRoute.href, '_blank');
    },

      // 新闻动态获取三级页面详情页
      async goArticleDetail(artId) {
      
       
        if(this.typeObj !== 4){
          try {
            let objParams={
              artId:artId,
            }
            const res = await API.getArticleData(objParams)
            this.articleDetail=res.data.list[0]
            
            if (this.currentPage !== Math.ceil((this.columnListNow.indexOf(artId) + 1) / this.pageSize)) {
          await this.getlist2();
        }
        this.nowTab=res.data.list[0].name
            // 回到顶部
        document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
            console.log('获取成功', res.data.list)
          } catch (error) {
            console.error('获取失败', error)
          }
        }
  },
      handleNewsDetails(url) {
        // this.$router.push(`/news_detail/${id}`)
        window.open(url)
      },
      
     
    },
    watch: {
      $route() {
        this.optionActive =
          this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .mainbody{
  width: 100%;
 }

  .detail-pagination {
    width:80vw;
    margin: 2rem auto 0;
    padding: 1rem 0;
    border-top: 1px solid #eee;
  
    .pagination-bg {
      background: #f8f8f8;
      padding: 1.2rem;
      border-radius: 4px;
    }
  
    .prev-article, .next-article {
      line-height: 1.8;
      font-size: 0.95rem;
      
      + .next-article {
        margin-top: 0.8rem;
      }
    }
  
    .pagination-label {
      color: #999;
      margin-right: 0.5rem;
    }
  
    .article-title {
      color: #333;
      cursor: pointer;
      transition: color 0.3s;
  
      &:hover {
        color: #2091d3;
        text-decoration: underline;
      }
    }
  
    .no-article {
      color: #999;
    }
  }
  .report_wrap {
    // padding-bottom:8rem;
    background-size:100% 100%;
    padding-bottom: 5rem;
   
   
    .card_list {
      flex-wrap: wrap;
  
      .card_item {
        display: flex;
        margin-top: 1rem;
        padding: 20px;
        cursor: pointer;
        transition: all 0.5s;
  
        &:hover {
          box-shadow: 10px 10px 20px rgba($color: #000000, $alpha: 0.2);
          transform: scale(1.05);
        }
  
        .item_left {
          flex: 1;
  
          img {
            width: 90%;
            height: 100%;
            max-height: 350px;
            object-fit: cover;
            -webkit-user-drag: none;
          }
        }
  
        .item_right {
          flex: 1;
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
  
          h1 {
            color: #666;
            font-size: 28px;
  
            @media screen and (max-width: 768px) {
              font-size: 1rem;
            }
          }
  
          p {
            font-size: 13px;
  
            @media screen and (max-width: 768px) {
              &:nth-child(2) {
                display: none;
              }
  
              font-size: 13px;
            }
          }
        }
      }
    }
  }
  .report_wrap1 {
    // padding-bottom:8rem;
     background:url('../../assets/w/img3/dangjian1/dangjian-bg.png');
   background-size:cover;
  }

  .zhuan_column {
    width: 90%;
    text-align: center;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-evenly;
    @media screen and (max-width:768px) {
      h1.h1Mobile{
        font-size: 1.2rem;
        text-indent: 0 !important;
      }
    }
  
    img {
      width: 60%;
      height: 10rem;
    }
  
    .zhuan_item {
      @media screen and (max-width:768px) {
        &:nth-child(n+3) {
          margin-top: 10px;
        }
      }
  
      .zhuan_content {
        // padding: 14px;
        cursor: pointer;
        margin-bottom: 0.5rem;
        background: #ffffff;
  
        @media screen and (max-width:768px) {
          pad: 10px;
        }
  
        h1 {
          padding: 14px;
          min-height:2rem;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 1.0rem;
          line-height: 2rem;
          text-align: left;
         
  
          @media screen and (max-width:768px) {
            min-height: 55px;
          }
          a{
            max-height:4.5rem;
            display: block;
            color:#333333;
          }
          a:hover{
            color:#4a74f1;
          }
        }
        h5{
          font-size: 1rem;
        }
  
        .btn {
          background: #333333;
          float: right;
          color: #fff;
          margin-top: 20px;
          width: 80PX;
          height: 35PX;
          border-radius: 20PX;
  
          @media screen and (max-width:768px) {
            font-size: 12px;
          }
        }
  
        .details {
          padding:10px 14px;
          padding-top:0;
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          font-size: 0.9rem !important;
          text-align: left;
          line-height: 2rem;
          @media screen and (max-width:768px) {
            font-size: 13px;
          }
        }
  
        .desc {
          color: #666;
          min-height: 60px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          margin: 10px 0;
  
          @media screen and (max-width:768px) {
            font-size: 13px;
          }
        }
      }
    }
  }
  .zhuan_column1{
    flex-wrap: wrap;
    justify-content:left;
  }
  
  .video_column {
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-evenly;
  
    .video_item {
      .video_content {
        cursor: pointer;
        padding: 14px;
  
        h1 {
          color: #666;
          font-size: 0.9rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
  
          @media screen and (max-width:768px) {
            min-height: 65px;
          }
        }
      }
  
      img {
        width: 100%;
        min-height: 180px;
        cursor: pointer;
  
        @media screen and (max-width:768px) {
          min-height: 106px;
        }
      }
    }
  }
  
  .book_list_speial {
    padding-top: 16px;
    width: 70%;
    margin: 0 auto;
  }
  
  .scroll_btn2 {
    @media screen and (max-width:768px) {
      width: 280px;
      height: 35px;
      background: #fff !important;
      color: #151514 !important;
      border: solid 1px #333333 !important;
      font-size: 12px;
    }
  }
  .othernews3{
    background: #ffffff;
    display:flexbox;
    padding-bottom: 10px;
    // margin-top: 2rem;
    li{
        width: 100%;
        text-align: left;
        padding:10px;
        display: block;
        list-style: none;
        font-size: 1.2rem;
        font-weight: bold;
        color: #000000;
        line-height: 1.5rem;
        cursor: pointer;
        @media screen and (max-width:768px) {
           padding:1rem;
          //  font-size: 0.8rem;
        }
        a{
          color: #444444;
          font-size: 0.9rem;
          span{
              font-size: 0.9rem;
              color: #999999;
              float: right;
          }
        }
        a:hover{
          color: #2091d3;
          font-weight: bold;
        }
       
     }
    li.licss0{
      text-align: right;
      padding:0 10px;
      
      span{
        font-size: 0.9rem;
        color: #999999;
        font-weight: 100;
      }
    }
   
  }
  .othernews3:first{
   margin-top: 10px;
  }
  .othernews3:last-child{
    // box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  }
  .topH1{
    line-height: 5rem;
    text-align: left;
    width: 100%;
    // padding-left: 3.5%;
    cursor: pointer;
    span{
      font-size: 0.5rem;
      margin-left: 1rem;
      color: #999999;
    }
    a{
      font-weight: 100;
      font-size:1rem;
      color:#666666;
    }
  }
  .toptitle{
    width: 55%;
    height: 50px;
    cursor: pointer;
    background-color: aquamarine;
    border-radius: 0 50px 0 0;
    line-height: 50px; 
    font-size: 1.1rem;
    color: #ffffff;
    text-align: left;
    @media screen and (max-width:768px) {
        height: 3rem;
        border-radius: 0 2rem 0 0;
        line-height: 3rem;
        font-size: 1.2rem;
    }
    img{
      margin-left: 1rem;
    }
    
  }
  .toptitle0{
    background: #e36833;
  }
  .toptitle1{
    margin-top: 60px;
    background: #2091d3;
  }
  .toptitle2{
    background: #e6b802;
  }
  .toptitle3{
    margin-top: 60px;
    background: #d266ae;
  }
  .menu001{
    margin: 0 auto;
    width: 90%;
    margin-bottom: 1rem;
    // background: #d266ae;
   
    .el-col{
      text-align: center;
      // border: 1px solid #2091d3;
      margin-bottom: 0.5rem;
      padding:1rem 0.5rem;
      font-size: 1rem;
      @media screen and (max-width:768px) {
        padding:0;
      }
    }
     
  }
  
  .menucss0 .el-col:nth-child(1){
    background: #2091d3;
    color: #ffffff;
  }
  .menucss1 .el-col:nth-child(2){
    background: #2091d3;
    color: #ffffff;
  }
  .menucss2 .el-col:nth-child(3){
    background: #2091d3;
    color: #ffffff;
  }
  .menucss3 .el-col:nth-child(4){
    background: #2091d3;
    color: #ffffff;
  }
  .menucss4 .el-col:nth-child(5){
    background: #2091d3;
    color: #ffffff;
  }
  .el-card__body{
    // position: relative;
    .goDetailcss0{ 
      // background: #2091d3;
      color: #ffffff;
      height:2.5rem;
      line-height:2.5rem;
      display: block;
    }
    .goDetailcss0:hover{
      background: #2091d3;
    }
    .image{
    //  width: 100%;
     height:auto !important;
      
    }
    .image1{
      width: auto;
     max-width: 100%;
     height:300px !important;
    }
  }
  .cssCol{
    cursor: pointer;
  }
  .change_page{
    width: 90%;
    margin: 0 auto;
    margin-top: 1rem;
  }

  .articleDetailDiv{
    width: 90vw;
    margin: 0 auto;
    padding:0 70px 50px;
    border:  1px solid #e5e5e5;
    margin-bottom: 1rem;
    h1{
      width: 80%;
      margin:0 auto;
      margin-bottom: 1rem;
      border-bottom: 1px solid #999999;
      text-align: center;
      padding:1rem 0;
    }
    p{
      text-align: center;
    }
    div.contentcss0{
      margin: 0 auto;
      margin-top: 1rem;
      width:100%;
      // border: 1px solid #000000;
      // text-align: justify !important;
      color: #000000 !important;
      @media screen and (max-width:768px) {
        *{
          font-size: 0.5rem !important;
        }
     }
       
    }

     // 重置字体样式001
     div.contentcss0 :not(.keep-style) {
      // width: 90%;
      margin: 0 auto !important;
      // margin-top: 1rem;
      font-size:18PX !important;
      line-height: 2em !important;
      text-indent:2em !important;
      text-align: justify !important;
      word-break: break-all !important;
      // text-align: justify !important;
      @media (min-width: 0px) and (max-width: 991px) {
      span img{
          margin-left: -28px!important;
        }
      }
    }

   
  }

    // 重置图片样式 002
    div.contentcss0  img {
    border: var(--img-border, none) !important;
    width: var(--img-width, auto) !important;
    height: var(--img-height, auto) !important;
  }

  /* 使用深度选择器（Vue 2/3 兼容写法） */
  .contentcss0 >>> img,.contentcss0 ::v-deep img,.contentcss0 :deep(img) {
    border: none !important; /* 移除边框 */
    padding: 0 !important;
    // margin: 0!important;
    box-shadow: none !important;
    display: block;
    margin:0 auto !important;
    width: 60% !important;
  }
  .contentcss0 >>> table,.contentcss0 ::v-deep table,.contentcss0 :deep(table) {
    
    margin:0 auto !important;
    width: 80% !important;
  }
 
  .procard_btn {
    width: 100%;
    display: flex;
    .mobileGkmenu{
      display:none;
    }
    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        display:none;
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;
      &::before {
        // content: '▲';
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
    @media screen and (max-width: 768px) {
      
        .mobileGkmenu{
          display:block;
          width:100%;
          height:8rem;
          .mobileGkdiv{
            background:#e5e5e5;
            margin:0.25rem;
            line-height:2rem;
            text-align:center;
          }
          .active {
            color: #fff;
            background: #2091d3;
            font-weight: bold;
            &::before {
              content: '';
            }
          }
        }
    }
  }
  .nodatadiv{
    width:100%;
    text-align: center;
    font-size:1rem;
    padding:1rem;
    background: #e5e5e5;
  }
  .videoDiv{
    width: 50%;
    margin:0 auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    video{
      width: 100%;
      height: auto;
    }
   
  }
 .videoDetail{
  text-align: center;
  font-weight: bold;
  color: #000000;
  height: 2rem;
  line-height: 2rem;
 }

//  .menus{
//   background: #e5e5e5;
//   padding:0.5rem;
//   font-size:1rem;
//   color:#333;
//   margin-bottom:0.5rem !important;
//   a{
//     // color:#015293;
//     color:#333;
//   }
//  }
 .Lmenu{
  margin-top:1rem;
  // padding:1rem;
  margin-bottom:0.5rem;
  font-size:1rem;
  background:#eee;
  text-align:center;
  a{
    display: block;
    width: 100%;
    padding:1rem;
    // background: #d38220;
    color:#666;
  }
  a:hover{
    // background: linear-gradient(to right, rgba(135, 212, 243, 0.5),#2091d3);
    background: #015293;
  transition: background 0.5s ease;
    color:#ffffff;
  }
 }
 .active{
  // background: linear-gradient(to right, rgba(149, 216, 243, 0.5),#2091d3);
  background: #015293;

  transition: background 0.5s ease;
    a{
      color:#ffffff;
   }
  }
  .Rcontent{
  display:flexbox;
  padding:1rem;
  padding-top:0;
  background:#ffffff;
  margin-left:3.5rem;
  @media screen and (max-width: 768px) {
    margin-left:0;
  }
    ul{
      li{
        list-style:none;
        // padding:1rem;
        line-height:1rem;
        border-bottom:1px solid #e5e5e5;
        display:flex;
        .Rtime{
          flex:5%;
          padding:0.8rem;
          background:#e5e5e5;
          font-size:1rem;
          font-weight:bold;
          color:#dab773;
        }
        .Rtitle{
          flex:85%;
          padding:1.0rem;
          font-size:1rem;
          overflow: hidden;
         
          a{
            // background: #2091d3;
            color:#333;
            line-height: 2rem;
          }
          a:hover{
            // color:#257bec;
            color: #015293;

            font-weight: bold;
          }
        }
      }
      li.lastLi{
        border-bottom:none;
      }
    }
 } 

 a.imgA {
  display: inline-block;
  // background: white;
  width: 100%;
  height: 240px;

  text-align: center;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: all 1s ease;
  img{
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    height: 20vh;
  }
  
}

a.imgA:hover {
  width: 120%;
  height: 240px;
  // height: 120%;
  transform: translateX(-10%);
  // transform: translateY(-10%);
   
}
::v-deep .el-card.is-always-shadow{
  // box-shadow:0 0.10417vw .925vw 0 rgb(0 0 0 / 80%);
  // box-shadow: 10px 1px 20px 0 rgba(0,0,0,0.6);
}
::v-deep .el-card{
  background: none !important;
}
 
.articleDetailDiv {
    div.contentcss0big :not(.keep-style) {
        font-size: 20PX !important;
        color: #000000;
    }

    div.contentcss0small :not(.keep-style) {
        font-size: 16PX !important;
        color: #000000;
    }
}


  </style>